<template>
  <div class="orangehrm-background-container orangehrm-employee-data-page">
    <div class="orangehrm-card-container">
      <div class="orangehrm-edit-employee">
        <div class="orangehrm-edit-employee-navigation">
          <div class="orangehrm-edit-employee-imagesection">
            <div class="orangehrm-edit-employee-name">
              <oxd-text tag="h6" class="--strong">{{ employeeName }}</oxd-text>
              <oxd-text v-if="!isCurrentEmp" type="subtitle-2">
                {{ $t('general.past_employee') }}
              </oxd-text>
            </div>
            <div class="orangehrm-edit-employee-image-wrapper">
              <div class="orangehrm-edit-employee-image">
                <img
                  alt="profile picture"
                  class="employee-image"
                  :src="imgSrc"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="orangehrm-edit-employee-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatEmployeeFullName} from '@/core/util/helper/employeeDisplayName';
import {computed, ref} from 'vue';
import {APIService} from '@/core/util/services/api.service';
const defaultPic = `${window.appGlobal.publicPath}/images/default-photo.png`;

export default {
  name: 'EmployeeDataLayout',
  props: {
    employeeId: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    allowedFileTypes: {
      type: Array,
      required: true,
    },
    maxFileSize: {
      type: Number,
      required: true,
    },
    screen: {
      type: String,
      default: 'personal',
      validator(value) {
        return ['personal'].includes(value);
      },
    },
  },
  setup(props) {
    const employeeName = ref('');
    const isCurrentEmp = ref(true);
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/pim/employees',
    );

    http.get(props.employeeId).then(({data}) => {
      employeeName.value = formatEmployeeFullName(data.data);
      isCurrentEmp.value = data.data.terminationId ? false : true;
    });

    const imgSrc = computed(() => {
      return props.employeeId
        ? `${window.appGlobal.baseUrl}/pim/viewPhoto/empNumber/${props.employeeId}`
        : defaultPic;
    });
    return {
      imgSrc,
      employeeName,
      isCurrentEmp,
    };
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-employee-data-page {
  &.orangehrm-background-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    height: auto;
    padding: 1rem 1rem 2rem;
    box-sizing: border-box;
    overflow-x: hidden;

    @include oxd-respond-to('md') {
      align-items: center;
      padding: 2rem 1rem;
    }
  }

  .orangehrm-card-container {
    box-shadow: 3px 3px 10px $oxd-interface-gray-color;
    width: 100%;
    max-width: 920px;
    margin: 0 auto;
    padding: unset;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  :deep(.orangehrm-card--details-container) {
    overflow: visible;
  }

  :deep(.orangehrm-horizontal-padding.orangehrm-vertical-padding) {
    padding-bottom: 2rem;
  }

  :deep(.oxd-form-actions) {
    padding-bottom: 0.5rem;
  }
}

.orangehrm-edit-employee-imagesection {
  width: 100%;
}

.orangehrm-edit-employee {
  display: flex;
  @include oxd-respond-to('xs') {
    flex-direction: column;
  }
  @include oxd-respond-to('md') {
    flex-direction: row;
  }
  &-navigation {
    width: 100%;
    padding: 1rem;
    box-sizing: border-box;
    flex-shrink: 0;
    @include oxd-respond-to('md') {
      width: 220px;
    }
  }
  &-content {
    flex: 1;
    min-width: 0;
    @include oxd-respond-to('md') {
      border-left: $oxd-input-control-border--active;
    }
  }
  &-name {
    width: 100%;
    text-align: center;
    padding-left: 1rem;
    padding-right: 1rem;
    word-break: break-word;
    & .--strong {
      font-weight: 700;
      font-size: 1.2rem;
    }
  }
  &-image-wrapper {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 0.5rem;
    @include oxd-respond-to('md') {
      padding-top: 1.2rem;
      padding-bottom: 1.2rem;
    }
  }
  &-image {
    width: 120px;
    height: 120px;
    min-width: 120px;
    min-height: 120px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    box-sizing: border-box;
    border: 0.5rem solid $oxd-background-pastel-white-color;
    box-shadow: 1px 1px 18px 11px hsl(238deg 13% 76% / 24%);

    .employee-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  &-imagesection {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
    width: 100%;
  }
}
</style>
